'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var POPUP_EVENTS = exports.POPUP_EVENTS = {
    OPEN_PANEL_MESSAGE: 'openpanel',
    POPUP_READY_MESSAGE: 'popupready',
    PANEL_READY_MESSAGE: 'panelready',
    PANEL_CLOSING_MESSAGE: 'panelclosing',
    CLOSE_PANEL_MESSAGE: 'closepanel',
    CLOSE_POPUP_MESSAGE: 'closepopup',
    ENFORCE_CLOSE_MESSAGE: 'sitereactdropdownenforceclose'
};

var MAX_PANEL_HEIGHT = exports.MAX_PANEL_HEIGHT = 305;
var PANEL_WIDTH = exports.PANEL_WIDTH = 272;
var LIST_ITEM_HEIGHT = exports.LIST_ITEM_HEIGHT = 36;
var FIELD_HEIGHT = exports.FIELD_HEIGHT = 42;
var MOUNT_TIMEOUT = exports.MOUNT_TIMEOUT = 500;

var COMPONENT_TYPES = exports.COMPONENT_TYPES = {
    SELECT_TYPE: 'select',
    DATE_PICKER_TYPE: 'datepicker'
};

var CLASSES = exports.CLASSES = {
    FIELD: 'wix-react-dropdown-field',
    FIELD_OPEN: 'wix-react-dropdown-field-open',
    FIELD_ERROR: 'wix-react-dropdown-field-error',
    FIELD_LABEL: 'wix-react-dropdown-label',
    FIELD_CHEVRON: 'wix-react-dropdown-field-chevron',
    FIELD_INNER: 'wix-react-dropdown-field-inner',
    FIELD_DISABLED: 'wix-react-dropdown-field-disabled',

    PANEL_WRAPPER: 'wix-react-dropdown-panel-wrapper',

    DATE_PICKER_CLOSE: 'wix-react-dropdown-datepicker-close',
    DATE_PICKER_CHEVRON: 'wix-react-dropdown-datepicker-chevron',
    DATE_PICKER_CHEVRON_DISABLED: 'wix-react-dropdown-chevron-disabled',
    DATE_PICKER_DAY: 'wix-react-dropdown-day',
    DATE_PICKER_DAY_DISABLED: 'wix-react-dropdown-day-disabled',
    DATE_PICKER_DAY_HOVERED: 'wix-react-dropdown-day-hovered',
    DATE_PICKER_DAY_SELECTED: 'wix-react-dropdown-day-selected',
    DATE_PICKER_MARKER: 'wix-react-dropdown-marker',

    SELECT_OPTION: 'wix-react-dropdown-option',
    SELECT_OPTION_MARKED: 'wix-react-dropdown-option-nav'
};

var FRAME_TYPES = exports.FRAME_TYPES = {
    FIELD_FRAME: 'field_frame',
    PANEL_FRAME: 'panel_frame'
};

var KEY_CODES = exports.KEY_CODES = {
    ESC: 27,
    ENTER: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SPACE: 32,
    TAB: 9,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    HOME: 36,
    END: 35
};

var BASE_DROPDOWN_URL = exports.BASE_DROPDOWN_URL = 'https://www.wix.com/site-react-dropdown';